import React from "react";
import { Link } from "react-router-dom";

const PurchaseReturn = ({ onMenuClick, active }) => {
  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/accounts" ||
            active === "/chart-of-account" ||
            active === "/budget-plan" ||
            active === "/journal-code" ||
            active === "/sub-category" ||
            active === "/journal-voucher" ||
            active === "/cash-count" ||
            active === "/setup"
              ? "active show-sub"
              : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>&nbsp;&nbsp; Purchase and Return</span>
        </Link>
        <ul className="nav-sub">
          
          
          {/* Supply Chain PurchaseReturn */}
          {/* <li className="nav-item">
            <Link
              to="/banks"
              className={`nav-link ${active === "/banks" ? "active" : ""}`}
              onClick={() => onMenuClick("/banks")}
            >
              <i className="fa fa-university" aria-hidden="true"></i>
              &nbsp;&nbsp; Banks
            </Link>
          </li> */}
          <li className="nav-item">
                              <Link
                                to="/others-receive"
                                className={`nav-link ${
                                  active === "/others-receive" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/others-receive")}
                              >
                                <i className="fa fa-inbox" aria-hidden="true"></i>
                                &nbsp;&nbsp; Direct Purchase
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/direct-purchase"
                                className={`nav-link ${
                                  active === "/direct-purchase" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/direct-purchase")}
                              >
                                <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                                &nbsp;&nbsp; Purchase Order
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/grn"
                                className={`nav-link ${
                                  active === "/grn" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/grn")}
                              >
                                <i className="fa fa-truck" aria-hidden="true"></i>
                                &nbsp;&nbsp; Product Receive (GRN)
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/purchase-order-return"
                                className={`nav-link ${
                                  active === "/purchase-order-return" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/purchase-order-return")}
                              >
                                <i className="fa fa-exchange" aria-hidden="true"></i>
                                &nbsp;&nbsp; GRN Wise Purchase Return
                              </Link>
                            </li>
        </ul>
      </li>
    </>
  );
};

export default PurchaseReturn;
